import { toast } from "react-toastify";

export const validateFields = (fields, t) => {
  for (let field of fields) {
    const { value, labelKey } = field;

    if (!value || value.trim() === '') {
      toast.warning(`${t('msg_pleaseEnter')} ${t(labelKey)}`);
      return false;
    }
  }

  return true;
};
